module.exports = function ($sce, settingsService) {
    return {
        restrict: 'E',
        scope: {},
        link(scope) {
            const init = function () {
                //Coopyright text setting
                settingsService.getSettingValue('Copyright', 'OnesiteCopyrightFooterHtml').then(function (setting) {
                    scope.copyrightFooter = $sce.trustAsHtml(setting);
                });
            };
            init();

        },

        template: require('./copyright-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/copyright/copyright-directive.js
 **/